import React, { useState, useEffect } from 'react';
import { UserEndpoint } from '../../api';
import MyAccountSidebar from './my-account-sidebar';
import Profile from './account_menu/profile';
import MyProperty from './account_menu/myproperty';
import RentProperty from './account_menu/rentproperty';
import Dashboard from './account_menu/dashboard';
import AddProperty from './account_menu/addproperty';
import ManagedProperty from './account_menu/managedproperty';

const MyAccount = () => {
	const [activePane, setActivePane] = useState("dashboard")
	const [userData, setUserData] = useState({
		id: "",
		name: "",
		address: "",
		email: "",
		phone_number: "",
		profile_photo: "",
	});

	const [originalUserData, setOriginalUserData] = useState({
		id: "",
		name: "",
		address: "",
		email: "",
		phone_number: "",
		profile_photo: "",
	});

	const [profileStatus, setProfileStatus] = useState({
		type: "", // 'success' | 'error'
		message: "",
	});

	const handleProfileChange = (e) => {
		const { name, value } = e.target;

		const updatedUser = {
			...userData,
			[name]: value,
		};

		setUserData(updatedUser);
		setProfileStatus({ type: "", message: "" });
	};

	const handleProfileSubmit = async (e) => {
		e.preventDefault();

		// Check if any data has changed
		const changedFields = {};
		Object.keys(userData).forEach(key => {
			if (userData[key] !== originalUserData[key]) {
				changedFields[key] = userData[key];
			}
		});

		// If no changes, show a message
		if (Object.keys(changedFields).length === 0) {
			setProfileStatus({
				type: "info",
				message: "No changes detected.",
			});
			return;
		}

		try {
			const userEndpoint = new UserEndpoint();
			await userEndpoint.updateUser(changedFields);
			setProfileStatus({
				type: "success",
				message: "Profile updated successfully.",
			});
			// Update original data to reflect the changes
			setOriginalUserData(userData);
		} catch (error) {
			console.error("Failed to update user data", error);
			setProfileStatus({
				type: "error",
				message:
					error?.response?.data?.message ||
					"Failed to update profile. Please try again.",
			});
		}
	};

	useEffect(() => {
		const fetchUser = async () => {
			try {
				const allowedRoles = ["owner", "management"];

				const userEndpoint = new UserEndpoint();
				const response = await userEndpoint.getUser();
				// Assuming response is already the user object as in the example:
				// { id, name, address, email, phone_number, profile_photo }
				setUserData(response);
				setOriginalUserData(response);
			} catch (error) {
				console.error("Failed to fetch user data", error);
			}
		};

		fetchUser();
	}, []);

	const componentMap = {
		dashboard: Dashboard,
		myaccount: Profile,
		myproperty: MyProperty,
		rentproperty: RentProperty,
		addproperty: AddProperty,
		managedproperty: ManagedProperty
	}

	return (
		<div className="liton__wishlist-area pb-70">
			<div className="container">
				<div className="row">
					<div className="col-lg-12">
						{/* PRODUCT TAB AREA START */}
						<div className="ltn__product-tab-area">
							<div className="container">
								<div className="row">
									<div className="col-lg-4">
										<MyAccountSidebar activePane={activePane} setActivePane={setActivePane} />
									</div>
									<div className="col-lg-8">
										{(() => {
											const Component = componentMap[activePane];
											if (!Component) return <div>Invalid menu</div>;
											return (
												<Component
													userData={userData}
													handleProfileChange={handleProfileChange}
													handleProfileSubmit={handleProfileSubmit}
													profileStatus={profileStatus}
												/>
											);
										})()}
									</div>

								</div>
							</div>
						</div>
					</div>
					{/* PRODUCT TAB AREA END */}
				</div>
			</div>
		</div>
	);
}

export default MyAccount